import htmlTemplate from './company-information.directive.html';

(function() {
    "use strict";

    angular.module("cardspotWeb.areas.hvtRequest")
        .directive("emlCompanyInformation", configDirective);

    function configDirective() {
        return {
            restrict: "E",
            scope: {
                companyInformation:"=",
                companyInformationComplete:"=",
                countries:"=",
                previousStep:"="
            },
            controller: CompanyInformationController,
            controllerAs: "model",
            template: htmlTemplate
        };
    }

	CompanyInformationController.$inject = ["$q", "$scope", "$rootScope", "$translate", "lookupValues", "REGION_TYPES", "SF_EVENTS",
        "HVT_REQUEST_TYPES"
    ];

	function CompanyInformationController($q, $scope, $rootScope, $translate, lookupValues, REGION_TYPES, SF_EVENTS,
        HVT_REQUEST_TYPES
    ) {
        var model = this;
        model.regions;
        model.showRegionSelection = false;
        model.companyInformationRegionModel = companyInformationRegionModel;
        model.countrySelectionChanged = countrySelectionChanged;
        $scope.HVT_REQUEST_TYPES = HVT_REQUEST_TYPES;
        $scope.forms = {};
        model.naicsCodeRequired = naicsCodeRequired;

        $rootScope.$on(SF_EVENTS.HVT_REQUEST_COMPANY_STEP_SELECTED, function(event, args) {
            initRegions();
        })

        $rootScope.$on(SF_EVENTS.HVT_REQUEST_SUCCEEDED, handleRequestSucceeded);

        function countrySelectionChanged() {
            $scope.companyInformation.postalCode = null;
            $scope.companyInformation.state = null;
            $scope.companyInformation.province = null;
            $scope.companyInformation.stateRequired = false;
            $scope.companyInformation.provinceRequired = false;
            initRegions();
            naicsCodeRequired();
        }

        function initRegions() {
            if ($scope.companyInformation.country) {
                lookupValues.getRegions($scope.companyInformation.country.countryKey)
                .then(function (regions) {
                    model.regions = regions;
                    model.showRegionSelection = $scope.companyInformation.country && hasRegions() && $scope.companyInformation.country.regionType !== REGION_TYPES.NONE;
                    
                    if ($scope.companyInformation.requestType === HVT_REQUEST_TYPES.CORPORATE) {
                        if ($scope.companyInformation.country.regionType === REGION_TYPES.STATE)
                            $scope.companyInformation.stateRequired = model.showRegionSelection;
                        else if ($scope.companyInformation.country.regionType === REGION_TYPES.PROVINCE)
                            $scope.companyInformation.provinceRequired = model.showRegionSelection;
                    }
                });
            }
        }

        function companyInformationRegionModel(newRegion) {
            if ($scope.companyInformation && $scope.companyInformation.country) {
                if ($scope.companyInformation.country.regionType === REGION_TYPES.STATE) {
                    return arguments.length ? ($scope.companyInformation.state = newRegion) : $scope.companyInformation.state ?? "";
                } else {
                    return arguments.length ? ($scope.companyInformation.province = newRegion) : $scope.companyInformation.province ?? "";
                }
            }
        }

        function hasRegions() {
            return angular.isArray(model.regions) && model.regions.length > 0;
        }
        
        function handleRequestSucceeded() {
            $scope.forms?.companyInfoForm?.$setPristine();
        }

        function naicsCodeRequired() {
            return $scope.companyInformation.country?.countryName === "United States" 
            || $scope.companyInformation.country?.countryName === "Canada" 
            || $scope.companyInformation.country?.countryName === "Mexico";
        }
    }
}());